import googleDeveloperGroup from './assets/googleDeveloperGroup.jpg'
import indieHackers from './assets/indieHackers.webp'

export const COMMUNITY_DATA = [
  {
    title: 'Indie Hackers Cape Town',
    period: '2018 to present',
    desc: 'I founded Indie Hackers Cape Town and more than 8 years later it is still going strong! It is a place where makers & founders can share their stories, learnings and experiences. The goal of the meetup is to speak about what participants actually care about, using a facilitation method based on un-conferencing. We have a 4.8 rating on Meetup!',
    links: [{ label: 'More info', href: 'https://www.meetup.com/Indie-Hackers-Cape-Town/' }],
    image: indieHackers,
  },
  {
    title: 'Google Developer Group',
    desc: 'A place where developers can share what they are working on and new technologies they are learning. I helped organize the meetups and spoke at a few of them.',
    period: '2018 - 2021',
    links: [{ label: 'More info', href: 'https://gdg.community.dev/gdg-cape-town/' }],
    image: googleDeveloperGroup,
  },
]
